import { AnimatePresence, motion } from "motion/react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/config/routes";
import { useGetEpisodeHistory } from "@/hooks/api/feed.hooks";
import { cn } from "@/utils/cn";

import IconStar from "../icons/IconStar";

const DetailRateMobileButton = ({ id, className }: { id: number; className?: string }) => {
  const { t } = useTranslation();

  const { data: history, isPending } = useGetEpisodeHistory(id);

  const navigate = useNavigate();

  const navigateToRate = () => {
    navigate(ROUTES.DETAIL.RATE.replace(":id", id.toString()));
  };

  const rated = history?.rating || history?.rating_text;

  return (
    <AnimatePresence mode="wait">
      {isPending ? (
        <div className="group flex flex-col items-center gap-2">
          <div className="size-6 animate-pulse rounded-lg bg-surface-bright"></div>
          <div className="h-5 w-[60%] animate-pulse rounded-lg bg-surface-bright"></div>
        </div>
      ) : (
        <motion.button
          type={"button"}
          exit={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={navigateToRate}
          initial={{ opacity: 0 }}
          title={t("bookmarks-add")}
          key={rated?.toString()}
          className={cn("group flex flex-col items-center gap-2 transition-all", className)}
        >
          <IconStar
            className={cn("size-6 fill-transparent stroke-on-primary", {
              "fill-primary stroke-primary": rated,
            })}
          />
          <p className={cn("text-[14px] text-on-primary", { "text-primary": rated })}>
            {t(rated ? "Actions.estimated" : "Actions.estimate")}
          </p>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default DetailRateMobileButton;
